// eslint-disable-next-line no-unused-vars
import React from 'react';

import ProductCardContainer from 'Containers/Templates/ProductCard';

const ProductCard = {
  label: 'Product Card',
  fields: {
    productId: { type: 'text', label: 'Product ID' },
    title: { type: 'text', label: 'Title' },
    specs: {
      type: 'array',
      label: 'Extra specs',
      arrayFields: {
        label: { type: 'text', label: 'Label' },
        value: { type: 'textarea', label: 'Value' },
      },
      getItemSummary: item => item.label || item.value || 'Spec',
    },
  },
  defaultProps: {
    productId: '',
    title: '',
    specs: [],
  },
  render: ({ productId, title, specs }) => (
    <ProductCardContainer
      productId={ productId }
      title={ title }
      specs={ specs }
    />
  ),
};

export { ProductCard };
